import { render, staticRenderFns } from "./setLogModel.vue?vue&type=template&id=c3147144&scoped=true&"
import script from "./setLogModel.vue?vue&type=script&lang=js&"
export * from "./setLogModel.vue?vue&type=script&lang=js&"
import style0 from "./setLogModel.vue?vue&type=style&index=0&id=c3147144&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3147144",
  null
  
)

export default component.exports